module.exports = __webpack_public_path__ + "img/map-pin.4e46b631.svg";